const en = {
  label: '🇬🇧 English',
  ipa: {
    98: {
      ex: (
        <span>
          <b>b</b>uy, ca<b>b</b>
        </span>
      ),
    },
    100: {
      ex: (
        <span>
          <b>d</b>ye, ca<b>d</b>, la<b>dd</b>er
        </span>
      ),
    },
    106: {
      ex: (
        <span>
          <b>y</b>es, hallelu<b>j</b>ah
        </span>
      ),
    },
    107: {
      ex: (
        <span>
          <b>k</b>ind, s<b>k</b>y, <b>c</b>ra<b>ck</b>
        </span>
      ),
    },
    102: {
      ex: (
        <span>
          <b>f</b>ind, lea<b>f</b>
        </span>
      ),
    },
    104: {
      ex: (
        <span>
          <b>h</b>igh, a<b>h</b>ead
        </span>
      ),
    },
    105: {
      ex: (
        <span>
          happ<b>y</b>, rad<b>i</b>o
        </span>
      ),
    },
    108: {
      ex: (
        <span>
          <b>l</b>ie, p<b>l</b>y, ga<b>l</b>
        </span>
      ),
    },
    109: {
      ex: (
        <span>
          <b>m</b>y, s<b>m</b>ile, ca<b>m</b>
        </span>
      ),
    },
    110: {
      ex: (
        <span>
          <b>n</b>igh, s<b>n</b>ide, ca<b>n</b>
        </span>
      ),
    },
    112: {
      ex: (
        <span>
          <b>p</b>ack
        </span>
      ),
    },
    114: {
      ex: (
        <span>
          <b>r</b>ye, t<b>r</b>y, ve<b>r</b>y
        </span>
      ),
    },
    115: {
      ex: (
        <span>
          <b>s</b>igh, ma<b>ss</b>
        </span>
      ),
    },
    116: {
      ex: (
        <span>
          <b>t</b>ie, s<b>t</b>y, ca<b>t</b>, la<b>tt</b>er
        </span>
      ),
    },
    117: {
      ex: (
        <span>
          fr<b>u</b>ition
        </span>
      ),
    },
    118: {
      ex: (
        <span>
          <b>v</b>ie, lea<b>v</b>e
        </span>
      ),
    },
    119: {
      ex: (
        <span>
          <b>w</b>ine, s<b>w</b>ine
        </span>
      ),
    },
    120: {
      ex: (
        <span>
          lo<b>ch</b>
        </span>
      ),
    },
    122: {
      ex: (
        <span>
          <b>z</b>oo, ha<b>s</b>
        </span>
      ),
    },
    230: {
      ex: (
        <span>
          tr<b>a</b>p, t<b>a</b>ttoo, s<b>a</b>ng
        </span>
      ),
    },
    240: {
      ex: (
        <span>
          <b>th</b>y, brea<b>th</b>e, fa<b>th</b>er{' '}
        </span>
      ),
    },
    331: {
      ex: (
        <span>
          campi<b>ng</b>
        </span>
      ),
    },
    594: {
      ex: (
        <span>
          l<b>o</b>t, bl<b>o</b>ckade, c<b>o</b>t, b<b>o</b>ther
        </span>
      ),
    },
    601: {
      ex: (
        <span>
          b<b>a</b>zaar, comm<b>a</b>
        </span>
      ),
    },
    603: {
      ex: (
        <span>
          dr<b>e</b>ss, pr<b>e</b>stige, l<b>e</b>ngth
        </span>
      ),
    },
    609: {
      ex: (
        <span>
          <b>g</b>uy, ba<b>g</b>
        </span>
      ),
    },
    618: {
      ex: (
        <span>
          k<b>i</b>t, h<b>i</b>storic, s<b>i</b>ng
        </span>
      ),
    },
    643: {
      ex: (
        <span>
          <b>sh</b>y, ca<b>sh</b>
        </span>
      ),
    },
    650: {
      ex: (
        <span>
          f<b>oo</b>t
        </span>
      ),
    },
    652: {
      ex: (
        <span>
          g<b>u</b>t, s<b>u</b>ng
        </span>
      ),
    },
    658: {
      ex: (
        <span>
          plea<b>s</b>ure, bei<b>g</b>e, vi<b>s</b>ion
        </span>
      ),
    },
    952: {
      ex: (
        <span>
          <b>th</b>igh, <b>th</b>ank
        </span>
      ),
    },
    0x025102d0: {
      ex: (
        <span>
          p<b>a</b>lm, br<b>a</b>, f<b>a</b>ther
        </span>
      ),
    },
    0x61026a: {
      ex: (
        <span>
          pr<b>i</b>ce, p<b>ie</b>
        </span>
      ),
    },
    0x61028a: {
      ex: (
        <span>
          m<b>ou</b>th, h<b>o</b>w
        </span>
      ),
    },
    0x65026a: {
      ex: (
        <span>
          f<b>a</b>ce
        </span>
      ),
    },
    0x6902d0: {
      ex: (
        <span>
          fl<b>ee</b>, Gr<b>ee</b>ce
        </span>
      ),
    },
    0x6f028a: {
      ex: (
        <span>
          g<b>oa</b>t
        </span>
      ),
    },
    0x025402d0: {
      ex: (
        <span>
          th<b>ou</b>ght, <b>au</b>thentic
        </span>
      ),
    },
    0x0254026a: {
      ex: (
        <span>
          ch<b>oi</b>ce
        </span>
      ),
    },
    0x7502d0: {
      ex: (
        <span>
          g<b>oo</b>se, cr<b>u</b>el
        </span>
      ),
    },
    0x690259: {
      ex: (
        <span>
          Californ<b>ia</b>
        </span>
      ),
    },
    0x750065: {
      ex: (
        <span>
          infl<b>ue</b>nce
        </span>
      ),
    },
    429553418898: {
      ex: (
        <span>
          <b>g</b>iant, ba<b>dg</b>e
        </span>
      ),
    },
    0x7403610283: {
      ex: (
        <span>
          <b>Ch</b>ina, ca<b>tch</b>
        </span>
      ),
    },
  },
};
export default en;
